import { render, staticRenderFns } from "./ServiceTaskForm.vue?vue&type=template&id=4eb1cbfc&scoped=true&"
import script from "./ServiceTaskForm.vue?vue&type=script&lang=ts&"
export * from "./ServiceTaskForm.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceTaskForm.vue?vue&type=style&index=0&id=4eb1cbfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb1cbfc",
  null
  
)

export default component.exports